import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { StatusTagDropdown, useDashboardPermissions } from '@components';
import { Banner, Toasts } from '@fourthwall/components';
import { reverse, routing } from '@utils/routing';
import { useOfferQuery } from '../hooks';
import { useStatusMutation } from '../hooks/useStatusMutation';
export const ProductStatusTagDropdownContainer = ({ size, }) => {
    const { productId = '' } = useParams();
    const navigate = useNavigate();
    const offerId = productId;
    const { offerQuery, setOfferData } = useOfferQuery([offerId]);
    const { statusMutation } = useStatusMutation();
    const { hasPermission, hasRole } = useDashboardPermissions();
    if (!offerQuery.isSuccess)
        return null;
    const { state, isSettingCostsRequired } = offerQuery.data;
    const { status, available } = state;
    const hasParentOffer = !!offerQuery.data.parentOffer;
    const renderMissingCost = () => {
        if (!isSettingCostsRequired)
            return;
        if (!hasRole('ROLE_COSTS_WRITE'))
            return;
        return (React.createElement("div", { style: { marginBottom: 16 } },
            React.createElement(Banner, { appearance: "warning" },
                "Product is missing costs.",
                ' ',
                React.createElement("button", { type: "button", onClick: () => {
                        navigate(reverse(routing.products.all.product.costs, { productId: offerId }));
                    } }, "Set it up"))));
    };
    const handleSubmit = async (values) => {
        const { status } = values;
        // StatusTagDropdown component still handles too many different statuses
        if (status === 'SCHEDULE')
            return;
        await statusMutation.mutateAsync({ offerId, params: { status } }, {
            onSuccess: (data) => {
                // TODO: decodeHtmlEntities
                setOfferData(data);
            },
            onError: (error) => {
                Toasts.notify(error.message, { type: 'error' });
            },
        });
    };
    return (React.createElement(StatusTagDropdown, { headerContent: renderMissingCost(), status: status, isSoldOut: !available, disabled: !hasPermission('products.edit.status') || status === 'ARCHIVED' || hasParentOffer, size: size, onSubmit: handleSubmit }));
};
